import { createSlice } from '@reduxjs/toolkit';

const initialState={
    curremms:null
}
export const currentEmmsSlice = createSlice({
  name: 'curremms',
  initialState,
  reducers: {

    setCurrentEmms: (state, action) => {
      state.curremms= action.payload;
    },
    setLogoutCurrentEmms: (state,action)=>{
      state.curremms=null
    }
  },
});

export const {  setCurrentEmms,setLogoutCurrentEmms } = currentEmmsSlice.actions;

export default currentEmmsSlice.reducer;
